import React from 'react';
import { BaseConfigProps } from '../shared/ConfigFormHelpers';

const OutputDisplayConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const config = node.data.config || {};
  const displayFormat = config?.displayFormat || 'json';
  const showTimestamp = config?.showTimestamp || false;
  const autoScroll = config?.autoScroll || true;

  const handleChange = (field: string, value: any) => {
    updateConfig(field, value);
  };

  return (
    <div className="space-y-4">
      <div className="bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-emerald-900 dark:text-emerald-100 mb-2">
          📊 Kimenet megjelenítő
        </h4>
        <p className="text-xs text-emerald-700 dark:text-emerald-300">
          Ez a node megjeleníti a flow végeredményét. Helyezd el a flow végére!
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Megjelenítési formátum
        </label>
        <select
          value={displayFormat}
          onChange={(e) => handleChange('displayFormat', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-emerald-500 dark:bg-gray-700 dark:text-gray-100"
        >
          <option value="json">JSON (formázott)</option>
          <option value="text">Szöveg (egyszerű)</option>
          <option value="table">Táblázat (ha array)</option>
        </select>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Válaszd ki, hogyan jelenjen meg az eredmény
        </p>
      </div>

      <div className="space-y-2">
        <div className="flex items-center">
          <input
            type="checkbox"
            id="showTimestamp"
            checked={showTimestamp}
            onChange={(e) => handleChange('showTimestamp', e.target.checked)}
            className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded"
          />
          <label htmlFor="showTimestamp" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
            Időbélyeg megjelenítése
          </label>
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            id="autoScroll"
            checked={autoScroll}
            onChange={(e) => handleChange('autoScroll', e.target.checked)}
            className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded"
          />
          <label htmlFor="autoScroll" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
            Automatikus görgetés az eredményhez
          </label>
        </div>
      </div>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-yellow-900 dark:text-yellow-100 mb-1">
          💡 Használat
        </h4>
        <p className="text-xs text-yellow-700 dark:text-yellow-300">
          Ez a node NEM küld kimenetet tovább - ez a flow végpontja. Teszteléshez és debug-oláshoz ideális.
        </p>
      </div>

      <div className="bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-emerald-900 dark:text-emerald-100 mb-2">
          📋 Példa kimenet
        </h4>
        <pre className="text-xs bg-white dark:bg-gray-800 p-2 rounded border border-emerald-200 dark:border-emerald-700 overflow-x-auto">
{`{
  "customers": [
    {
      "id": "cust123",
      "name": "Példa Kft.",
      "email": "info@example.com"
    }
  ],
  "count": 1,
  "timestamp": "2025-10-28T12:39:00Z"
}`}
        </pre>
      </div>
    </div>
  );
};

export default OutputDisplayConfig;
